// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const MarketingDataDocument = gql`
    mutation marketingData($input: MarketingDataInput!) {
  marketingData(input: $input) {
    success
  }
}
    `;

export function useMarketingDataMutation() {
  return Urql.useMutation<SchemaTypes.MarketingDataMutation, SchemaTypes.MarketingDataMutationVariables>(MarketingDataDocument);
};